<template>
  <div class="collapse clearfix"><slot></slot></div>
</template>

<script>
export default {
  name: "collapse",
  props: {
    isTransitioning: Boolean
  },
  data() {
    return {
      isOpen: false,
      isThisComponentTransitioning: false
    };
  },
  methods: {
    toggle() {
      if (this.isTransitioning || this.isThisComponentTransitioning) {
        return;
      }
      if (this.isOpen) {
        this.hide();
      } else {
        this.open();
      }
    },
    open() {
      const self = this;
      this.$emit("open");
      this.setTransitioning(true);
      this.isOpen = true;

      const el = this.$el;

      el.classList.add("collapsing");
      el.classList.remove("collapse");

      el.addEventListener("transitionend", function cb(e) {
        el.classList.add("collapse");
        el.classList.add("in");
        el.classList.remove("collapsing");
        el.style.height = "";

        self.setTransitioning(false);
        e.currentTarget.removeEventListener(e.type, cb);
      });

      el.style.height = el.scrollHeight + "px";
    },
    hide() {
      const self = this;
      this.$emit("close");
      this.setTransitioning(true);
      this.isOpen = false;

      const el = this.$el;

      el.style.height = el.getBoundingClientRect().height + "px";
      el.offsetHeight; // we have to force browser reflow

      el.classList.add("collapsing");
      el.classList.remove("collapse");
      el.classList.remove("in");

      el.addEventListener("transitionend", function cb(e) {
        el.classList.add("collapse");
        el.classList.remove("collapsing");

        self.setTransitioning(false);
        e.currentTarget.removeEventListener(e.type, cb);
      });

      el.style.height = "";
    },
    setTransitioning(result) {
      this.isThisComponentTransitioning = result;
      this.$emit("transitionchanged", result);
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/mixins";

.clearfix {
  @include clearfix;
}

.collapse {
  display: none;
  visibility: hidden;

  &.in {
    display: block;
    visibility: visible;
  }
}

.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition-property: height, visibility;
  transition-duration: 0.35s;
  transition-timing-function: ease;
}
</style>
